
import { Component, Prop, Vue } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'

@Component({
  name: 'Checkbox',
  components: {
    ChoiceIcon
  },
  model: {
    prop: 'data'
  }
})
export default class Checkbox extends Vue {
  @Prop({ type: String, default: 'p' }) el!: string
  @Prop({ type: String, default: '' }) id!: string
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ default: '' }) value!: string
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  @Prop({ type: Boolean, default: false }) checked!: boolean
  @Prop({ type: [Boolean, Array] }) data!: string | string[]
  // @ts-ignore
  @Prop({ type: String, default: 'check', validator: val => val.match(/check|cross/) }) type!: 'check' | 'cross'
  @Prop({ type: String, default: '' }) checkboxClasses!: string
  @Prop({ type: String, default: '' }) labelClasses!: string

  mounted() {
    if (this.checked) {
      this.emitState(this.checked)
    }
  }

  get isChecked() {
    if (this.value !== '') {
      return !!this.data && this.data.includes(this.value)
    } else {
      return this.data
    }
  }

  emitState(isChecked: boolean) {
    if (this.value !== '') {
      if (!Array.isArray(this.data)) { return }

      if (isChecked) {
        this.data.push(this.value)
      } else {
        this.data.splice(this.data.indexOf(this.value), 1)
      }

      this.$emit('input', this.data)
    } else {
      this.$emit('input', isChecked)
    }
  }

  change(ev: Event) {
    if (!ev.target) { return }

    this.emitState((ev.target as HTMLInputElement).checked)
  }
}
